import _ from "lodash";
import { Garage } from "./Garage";

/**
 * A bike object represents a read only configuration of a bike.
 * The model/platform and engine are included in the list of parts
 */
export class Bike {

    // ========================================
    // Constructor
    // ========================================

    constructor(json = {}) {

        // instance variables
        this._parts = [].concat(json.parts || []);
        console.log("[Bike] created");
    }

    get ready() {
        // TODO: we need to fix this to be a bit more accurate (@braini)
        return this._parts.length > 0;
    }

    get model() {
        return this._parts.find(p => p.subcategoryId === "Model");
    }

    get engine() {
        return this._parts.find(p => p.subcategoryId === "Engine");
    }

    get parts() {
        // return a new array containing the parts of this bike
        return [].concat.apply(this._parts)
    }

    get baseParts() {

        // get the part Ids for base parts
        const partIds = _.flatten(Object.keys(this.model.restrictions)
            .filter((item) => item.indexOf("Engine"))
            .map(key => this.model.restrictions[key]));

        return this._parts.filter(part => partIds.includes(part.id));
    }

    has(part) {
        return this._parts.some(item => item.id == part.id);
    }

    toJSON() {
        return {
            parts: this._parts,
        };
    }
}



// WEBPACK FOOTER //
// ./src/managers/Garage/Bike.js